'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _controller = require('./controller');

var Controller = _interopRequireWildcard(_controller);

var _model = require('./model');

var Model = _interopRequireWildcard(_model);

var _viewLogs = require('./view.logs.log');

var _viewLogs2 = _interopRequireDefault(_viewLogs);

var _util = require('./util');

var Util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Logs = function (_PureComponent) {
  _inherits(Logs, _PureComponent);

  function Logs() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Logs);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Logs.__proto__ || Object.getPrototypeOf(Logs)).call.apply(_ref, [this].concat(args))), _this), _this.handleClear = function () {
      _this.props.dispatch({
        type: 'Clear'
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Logs, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'p',
          { className: 'title is-5' },
          'Logs'
        ),
        this.props.state.logs.map(function (log, index) {
          return _react2.default.createElement(
            'p',
            { key: index, style: { margin: 2 } },
            _react2.default.createElement(_viewLogs2.default, {
              active: index === _this2.props.state.selectedLog,
              dispatch: _this2.props.dispatch,
              index: index,
              title: Util.actionTitle(log.action)
            })
          );
        }),
        _react2.default.createElement(
          'p',
          { style: { marginTop: 20 } },
          _react2.default.createElement(
            'a',
            {
              className: 'button is-danger is-fullwidth',
              onClick: this.handleClear
            },
            'Clear'
          )
        )
      );
    }
  }]);

  return Logs;
}(_react.PureComponent);

exports.default = Logs;


/*****************
 ** WEBPACK FOOTER
 ** ./~/devtools/dist/main/view.logs.js
 ** module id = 399
 ** module chunks = 0
 **/